import { Capacitor } from "@capacitor/core";
import getGpsLocationApp from "./getGpsLocationApp";
import getGpsLocationWeb from "./getGpsLocationWeb";

export default function getGpsLocation(callback) {
  const platform = Capacitor.getPlatform();

  if (platform === "android" || platform === "ios") {
    getGpsLocationApp(callback);
  } else if (platform === "web") {
    getGpsLocationWeb(callback);
  }
}
